var exports = {
  "D": "x31de4314--4c40de--title",
  "w": "x31de4314--4c40de--logo",
};

module.exports = exports;
